// Sliby: typované funkce nad api() podle smlouvy v packages/shared/src/promises.ts.
import type {
  ApiList,
  CreatePromiseInput,
  ListPromisesQuery,
  PromiseItem,
  UpdatePromiseInput,
} from '@wac-buddy/shared'
import { api } from './client'
import { buildQuery } from './query'

export type PromiseFilter = ListPromisesQuery['filter']

export interface ListPromisesParams {
  filter?: PromiseFilter
  clientId?: string
  jobId?: string
  assigneeId?: string
  cursor?: string | null
  limit?: number
}

export function listPromises(params: ListPromisesParams = {}): Promise<ApiList<PromiseItem>> {
  return api(
    `/promises${buildQuery({
      filter: params.filter,
      clientId: params.clientId,
      jobId: params.jobId,
      assigneeId: params.assigneeId,
      cursor: params.cursor,
      limit: params.limit,
    })}`,
  )
}

export function getPromise(id: string): Promise<PromiseItem> {
  return api(`/promises/${encodeURIComponent(id)}`)
}

export function createPromise(input: CreatePromiseInput): Promise<PromiseItem> {
  return api('/promises', { method: 'POST', body: JSON.stringify(input) })
}

export function updatePromise(id: string, input: UpdatePromiseInput): Promise<PromiseItem> {
  return api(`/promises/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  })
}

export function deletePromise(id: string): Promise<void> {
  return api(`/promises/${encodeURIComponent(id)}`, { method: 'DELETE' })
}
